import { useEffect, useState } from 'react';
import ConsultantList from '@src/cache/ConsultantList';

interface Props {
  id: string;
}

function ConsultantName({ id }: Props) {
  const { getList: getConsultants } = ConsultantList();
  const [display, setDisplay] = useState('');

  useEffect(() => {
    getConsultants(id).then((consultants) => {
      const consultant = consultants.find((c) => c.id === id);
      if (consultant) {
        let label = [
          consultant.title,
          consultant.lastName,
          consultant.firstName ? consultant.firstName.substring(0, 1) : '',
        ]
          .filter(Boolean)
          .join(' ');

        setDisplay(label);
      } else {
        setDisplay(id);
      }
    });
  }, [getConsultants, id]);

  return <span>{display}</span>;
}

export default ConsultantName;
